import React from "react"
import { Link } from "gatsby"

const CustomLink = props => {
  const urlMatch = new RegExp("https?://|//")

  if (props.url.match(urlMatch)) {
    return (
      <a
        target="_blank"
        rel="noopener noreferrer"
        className={props.className}
        href={props.url}
      >
        {props.children}
      </a>
    )
  }

  return (
    <Link
      to={props.url}
      activeClassName={props.activeClassName}
      className={props.className}
    >
      {props.children}
    </Link>
  )
}

export default CustomLink
